// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"a0e2e4ec","161":"ce8172f3","270":"2ca5b6b5","329":"ec827e30"}[chunkId] + ".css";
};